import { request } from 'src/utils/request';

const urls = {
  getAbnormalDocument: '/zlb/api/expense/apply-form/out/page',
  getUserBlowDep: '/zlb/api/expense/apply-form/zzd-org/query',
  setUserBlowDep: '/zlb/api/expense/apply-form/out/org/set',

};

// 异常单据搜索/异常单据数据查询
export function getAbnormalDocument (data) {
  return request(urls.getAbnormalDocument, { method: 'POST', data });
}



// 查询该用户下的挂名机构
export function getUserBlowDep (params) {
  return request(urls.getUserBlowDep, { method: 'GET', params });
}


// 订正该数据
export function setUserBlowDep (data) {
  return request(urls.setUserBlowDep, { method: 'POST', data });
}
